import { useNavigate } from 'react-router-dom';
import { useNavigationHistory } from './navigationHistory';

const BackButton = ({
  confirmMessage = '入力内容は破棄されますが、よろしいですか？'
}) => {
  const navigate = useNavigate();
  const { getPrevious } = useNavigationHistory();

  const handleBack = () => {
    const prev = getPrevious();

    if (!prev) return;

    const ok = window.confirm(confirmMessage);
    if (!ok) return;

    navigate(prev);
  };

  return (
    <button
      onClick={handleBack}
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        zIndex: 1000,
        padding: '10px 30px',
        borderRadius: '999px',
        border: 'none',
        background: '#ff2626',
        color: '#fff',
        cursor: 'pointer',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        fontSize: '20px'
      }}
    >
      ← 戻る
    </button>
  );
};

export default BackButton;
